import React, { useState, useEffect } from 'react';

const Typewriter = ({ text }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [index, setIndex] = useState(0);
    const handleScrollContainer = ()=>{
        const scrollContainer = document.getElementById('scrollable-element');
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
    useEffect(() => {
        if (index < text.length) {
            const timerId = setTimeout(() => {
                setDisplayedText((prevText) => prevText + text[index]);
                setIndex((prevIndex) => prevIndex + 1);
                handleScrollContainer()
            }, 100); // 每个字符显示的间隔时间，单位为毫秒

            return () => clearTimeout(timerId);
        }
    }, [index, text]);

    return <div>{displayedText}</div>;
};

export default Typewriter;
